import React, { useState } from 'react';
import PasswordChangeForm from './PasswordChangeForm';
import { updateDealerSettings } from '../../services/dealer';

const PasswordChangeFormContainer = () => {
    const [values, setValues] = useState({ newPassword: '', confirmPassword: '' });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleChange = e => {
        const { name, value } = e.target;
        setValues(prev => ({ ...prev, [name]: value }));
        setError('');
        setSuccess('');
    };

    const handleSubmit = async e => {
        e.preventDefault();
        setError('');
        setSuccess('');
        if (values.newPassword.length < 6) {
            setError('Password must be at least 6 characters long');
            return;
        }
        if (values.newPassword !== values.confirmPassword) {
            setError('Passwords do not match');
            return;
        }
        setIsSubmitting(true);
        try {
            const result = await updateDealerSettings({
                password: values.newPassword,
            })
            if (result.status === 'success') {
                setSuccess('Password changed successfully!');
                setValues({ newPassword: '', confirmPassword: '' });
            } else {
                setError(result?.message || 'Failed to change password');
            }
        } catch (error) {
            setError(error?.message || 'Failed to change password');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <PasswordChangeForm
            values={values}
            onChange={handleChange}
            onSubmit={handleSubmit}
            isSubmitting={isSubmitting}
            error={error}
            success={success}
        />
    );
};

export default PasswordChangeFormContainer; 